import web3Singletone from '../configWeb3';
import { abi, networks } from '../../build_sidechain/contracts/Reviews.json';
import { getFunctionOutputAbi, paramParser, getEventOutputAbi } from './contractHandle';

const SHOP_REVIEW_CUSTOMER = 0;
const CUSTOMER_REVIEW_SHOP = 1;

class Reviews {
  // reviewContract;
  // configWeb3;
  // privateKeyBase64;
  constructor(privateKeyBase64) {
    const web3 = web3Singletone.getWeb3(privateKeyBase64);
    this.publicAddress = web3Singletone.getPublicAddress(privateKeyBase64);
    this.reviewContract = new web3.eth.Contract(abi, networks[web3Singletone.getNetwork()].address, {
      from: this.publicAddress
    });
  }

  /**
   * Check status review of customer about a shop: //0: cannot review, 1: can review, 2: already reviewed
   * @param {*} orderId
   */
  async checkStatusReviewShop(orderId) {
    const result = await this.reviewContract.methods.checkStatusReviewShopByOrderId(orderId).call();
    return parseInt(result);
  }

  /**
   * Check status review of shop about a customer: //0: cannot review, 1: can review, 2: already reviewed
   * @param {*} orderId
   */
  async checkStatusReviewCustomer(orderId) {
    const result = await this.reviewContract.methods.checkStatusReviewCustomerByOrderId(orderId).call();
    return parseInt(result);
  }

  /**
   * Customer review about shop
   * @param {*} orderId order id
   * @param {*} star star
   * @param {*} comment comment
   */
  async addReviewToShop(orderId, star, comment) {
    const addReview = await this.reviewContract.methods.addReview(CUSTOMER_REVIEW_SHOP, orderId, star, comment).send();
    const eventOutputAbi = await getEventOutputAbi('NewReview', abi);
    const addReviewEvent = {};
    if (addReview && addReview.events && addReview.events.NewReview) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, addReview.events.NewReview.returnValues);
        addReviewEvent[parserValue.key] = parserValue.value;
        return true;
      });
    }

    return addReviewEvent;
  }

  /**
   * Shop add review about customer
   * @param {*} orderId orderId
   * @param {*} star star
   * @param {*} comment comment
   */
  async addReviewToCustomer(orderId, star, comment) {
    const addReview = await this.reviewContract.methods.addReview(SHOP_REVIEW_CUSTOMER, orderId, star, comment).send();
    const eventOutputAbi = await getEventOutputAbi('NewReview', abi);
    const addReviewEvent = {};
    if (addReview && addReview.events && addReview.events.NewReview) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, addReview.events.NewReview.returnValues);
        addReviewEvent[parserValue.key] = parserValue.value;
        return true;
      });
    }

    return addReviewEvent;
  }

  /**
   * Get infomation about a review by id
   * @param {*} reviewId review id
   */
  async getDetailReview(reviewId) {
    const rawResult = await this.reviewContract.methods.getReviewById(reviewId).call();
    const functionOutputAbi = await getFunctionOutputAbi('getReviewById', abi);
    const functionComponents = functionOutputAbi[0].components;
    const review = {};
    functionComponents.forEach(eachParam => {
      const parserValue = paramParser(eachParam, rawResult);
      review[parserValue.key] = parserValue.value;
    });
    return review;
  }

  /**
   * Update review infomation
   * @param {*} reviewId review id
   * @param {*} star star
   * @param {*} comment comment
   */
  async updateReview(reviewId, star, comment) {
    return await this.reviewContract.methods.updateReview(reviewId, star, comment).send();
  }

  /**
   * Get list review about shop
   * @param {*} reviewAddr cryptoAddress
   * @param {*} page page
   * @param {*} limit limit
   * @param {*} sortByDate 0 -> old to new, 1 new to old
   */
  async getListReviewsShop(reviewAddr, page, limit, sortByDate = 1) {
    const rawResult = await this.reviewContract.methods
      .getReviews(CUSTOMER_REVIEW_SHOP, reviewAddr, page, limit, sortByDate)
      .call();
    const functionOutputAbi = await getFunctionOutputAbi('getReviews', abi);
    const functionComponents = functionOutputAbi[0].components;
    const reviews = rawResult[0].map(result => {
      const order = {};
      functionComponents.map(eachParam => {
        const parserValue = paramParser(eachParam, result);
        return (order[parserValue.key] = parserValue.value);
      });
      return order;
    });
    return {
      reviews: reviews,
      count: parseInt(rawResult[1])
    };
  }

  /**
   * Get list review about customer
   * @param {*} customerAddress cryptoAddress
   * @param {*} page page
   * @param {*} limit limit
   * @param {*} sortByDate 0 -> old to new, 1 new to old
   */
  async getListReviewsCustomer(customerAddress, page, limit, sortByDate = 1) {
    const rawResult = await this.reviewContract.methods
      .getReviews(SHOP_REVIEW_CUSTOMER, customerAddress, page, limit, sortByDate)
      .call();
    const functionOutputAbi = await getFunctionOutputAbi('getReviews', abi);
    const functionComponents = functionOutputAbi[0].components;
    const reviews = rawResult[0].map(result => {
      const order = {};
      functionComponents.map(eachParam => {
        const parserValue = paramParser(eachParam, result);
        return (order[parserValue.key] = parserValue.value);
      });
      return order;
    });
    return {
      reviews: reviews,
      count: parseInt(rawResult[1])
    };
  }

  async getStatisticReviewCustomer(customerAddress) {
    const rawResult = await this.reviewContract.methods.getStatisticReviewCustomer(customerAddress).call();
    const functionOutputAbi = await getFunctionOutputAbi('getStatisticReviewCustomer', abi);
    const functionComponents = functionOutputAbi[0].components;
    const result = {};
    functionComponents.forEach(eachParam => {
      const parserValue = paramParser(eachParam, rawResult);
      result[parserValue.key] = parserValue.value;
    });
    return result;
  }

  getPublicAddress() {
    return this.publicAddress;
  }
}

export default Reviews;
